module.exports = __webpack_public_path__ + "img/icon-num3.29f29cd1.png";